import { Validator } from "class-validator";
import { differenceInYears } from "date-fns";
import parse from "date-fns/parse"
import SEX from '../../src/constants/sex.json'

//EMPTY
export const isEmpty = (value: any) => value === null || value === undefined || value === '';

//EMAIL
export const isValidEmail = (mail: string) => {

  let validator = new Validator()
  return validator.isEmail(mail)
  // /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(mail)
}

//COLLEGE NUMBER
export const isValidCollegeNumber = (collegeNumber: string) => /^\d{3,10}$/.test(collegeNumber);

//DATE
export const isValidDate = (date: string) => /^([0-2][0-9]|(3)[0-1])-|\/(((0)[0-9])|((1)[0-2]))-|\/\d{4}$/.test(date);


export const isValidNumber = (number: string) => /^\d+(\.\d+)?$/.test(number);



//Documento de Identidad (DNI/NIF, NIE, Passport)
export const isValidDocumentID = (text: string, elemID: string) => {
  if (['NIF', 'NIE', 'DNI'].includes(elemID)) {

    const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
    const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
    const nieRexp = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
    const str = text.toString().toUpperCase();

    if (elemID === 'NIF' && !nifRexp.test(str)) return false;
    if (elemID === 'NIE' && !nieRexp.test(str)) return false;

    let nie = str
      .replace(/^[X]/, '0')
      .replace(/^[Y]/, '1')
      .replace(/^[Z]/, '2');

    const letter = str.substr(-1);
    const charIndex = parseInt(nie.substr(0, 8)) % 23;

    if (validChars.charAt(charIndex) === letter) return true;

    return false;
  }
  
  if (elemID === 'PASP' || elemID === 'PAS') {
    const pass_esp = /^[a-z]{3}[0-9]{6}[a-z]?$/i
    const pass_world = /^[A-Za-z0-9]+$/i
    return (pass_esp.test(text) || pass_world.test(text));
  }
  
  if (elemID === 'PASSPORT') {
    const pass_esp = /^[a-z]{3}[0-9]{6}[a-z]?$/i
    return (pass_esp.test(text));
  }
  
  if (elemID === 'NIFP') {
    return true;
  }

  if (elemID === 'NIFA') {
    // Se pide misma validación que para DNI,
    // pero para poder trabajar el primer caracter tiene que poder ser una letra
    // https://sede.agenciatributaria.gob.es/Sede/censos-nif-domicilio-fiscal/solicitar-nif/nif-fisica.html
    const nifaRexp = /^[KLM0-9]\d{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
    const str = text.toString().toUpperCase();
    return nifaRexp.test(str);
  }

  return false
}

//PHONE (ES)
export const isValidPhone_ESP = (phone: string) => phone ? /^\d{9}$/.test(phone) : true;


export const isValidMobile = (mobile: string, locale:string = 'es-ES') => {
  const validator = new Validator();
  mobile = mobile.replace(' ', '');
  return validator.isMobilePhone(mobile, locale);
}

//PHONE INTERNATIONAL
export const isValidPhone = (number: string) => {

  let validator = new Validator()
  return number ? validator.isPhoneNumber(number, 'ZZ') : true
  // /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(mail)
}

//CARD
export const isValidCard = (text: string) => {
  if (!text || text.length < 18) return false

  const number = text.split(' ').join('')

  if (number.length < 15 || number.length > 16) return false

  if (
    number.length === 15 &&
    number.substr(0, 2) !== '34' &&
    number.substr(0, 2) !== '37'
  )
    return false

  if (number.length === 16) {
    const firstDigits = parseInt(number.substr(0, 2), 10)

    if (number.substr(0, 1) !== '4' && (firstDigits < 51 || firstDigits > 55))
      return false
  }

  return number.match(/[0-9]/)
}

//CIF
export const isValidCif = (text: string) => {
  if (!text || text.length !== 9) return false

  const letters = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'J',
    'N',
    'P',
    'Q',
    'R',
    'S',
    'U',
    'V',
    'W',
  ]
  const letter = text.substr(0, 1)
  const province = text.substr(1, 2)
  const control = text.substr(text.length - 1)

  if (letters.indexOf(letter) === -1) return false

  if (
    (['P', 'Q', 'R', 'S', 'W'].indexOf(letter) !== -1 || province === '00') &&
    !control.match(/[A-Z]/)
  )
    return false

  if (['A', 'B', 'E', 'H'].indexOf(letter) !== -1 && !control.match(/[0-9]/))
    return false

  const central = text.substr(1, 7)

  if (Number.isNaN(parseInt(central, 10))) return false

  let sum = 0

  central.split('').forEach((value, index) => {
    if ((index + 1) % 2 === 0) {
      sum += parseInt(value, 10)
    } else {
      let doubleValue = parseInt(value, 10) * 2
      if (doubleValue > 9) doubleValue -= 9
      sum += doubleValue
    }
  })

  const units = sum % 10
  const digit = units === 0 ? 0 : 10 - units
  const relation = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']

  if (control !== digit.toString() && control !== relation[digit]) return false

  return true
}

//PASSWORD
export const isValidPassword = (text: string) => {
  const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[=@$!%*#?&_.;-])[A-Za-z\d=@$!%*#?&_.;-]{6,}$/

  return text.length > 5;//regex.test(text)
}

export const hasNumber = (text: string) => {
  return /\d/.test(text)
}

export const isNumeric = (text: string) => {
  return /^\d+$/.test(text)
}

//IS UNDER-AGE
export const isUnderAge = (maxAge: number, birthdate: string) => {
  const birthDate = parse(
    birthdate
  )
  const age = differenceInYears(new Date(), birthDate)

  return (age <= maxAge)
}

export const isSupplementOptionEnabled = (user: any, rolesSuplementos: string[]) => {
  return user.roles && (rolesSuplementos.some((x: any) => user.roles.includes(x)) && user.code)
}

//MINUSCULAS
export const standardisedValidationFields = [
  'name',
  'lastname1',
  'lastname2',
  'birthdate',
  'newname',
  'newlastname1',
  'newlastname2',
  'newbirthdate',
  'petnewname',
  'newpetbirthdate',
]

export const validateSimulationFieldHealth = (value: string, key: string, isOnChangeEventValidation: boolean, required: boolean) => {
  const validation = checkStandardisedValidations(value, key, isOnChangeEventValidation, required)
  return ({
    validated: (validation && validation.isError) ? false : true,
    errorCode: validation ? validation.errorCode : ''
  })
}

export const validateStandarisedFieldsSupplements = (value: string, key: string, isOnChangeEventValidation: boolean) => {
  // //Las validaciones "required" se encuentran en métodos como basicDataRules o takerRules
  const isRequiredField = false
  const validation = checkStandardisedValidations(value, key, isOnChangeEventValidation, isRequiredField);
  return validation
    
}

//Health, Dental and Travel
export const validateStandarisedFieldsHealthHiring = (value: string, key: string, isOnChangeEventValidation: boolean, data: any ) => {
  const requiredFieldsToValidate = {
    name: true,
    lastName1: true,
    lastName2: (data.nationality && data.nationality.code === "ESPA"),
    birthDate: true,
  };
  const isRequiredField = (requiredFieldsToValidate as any)[key];

  const validation = checkStandardisedValidations(value, key, isOnChangeEventValidation, isRequiredField);
  if(validation && validation.isError){
    data[key].errorCode = validation.errorCode;
  };

  return validation
            
}

export const checkStandardisedValidations = (value: string, key: string, isOnChangeEventValidation: boolean, required: boolean, dataToUpdate?: any) => {

  if(!standardisedValidationFields.includes(key.toLowerCase())) return;
  const lowerCaseKey = key.toLowerCase();
        
  let isError = false;
  let errorCode = '';
  let validation = {
    isError,
    errorCode,
  }

  if(lowerCaseKey.includes('name')) {
    validation = validateNameOrLastname(isOnChangeEventValidation, lowerCaseKey, value, required);
  }else if(lowerCaseKey.includes('birthdate')){
    validation = validateBirthDatePatterns(value, required);
  }
  
  isError = validation.isError;
  errorCode = validation.errorCode;

  if(dataToUpdate){
    dataToUpdate.error = isError;
    dataToUpdate.errorCode = errorCode;
  }else{
    return {
      isError,
      errorCode,
    }
  }
    
}

export const validateNameOrLastname = (isOnChangeEventValidation: boolean, key: string, value: string, required: boolean) => {
  let isError = false;
  let errorCode = '';

  const dashValidations = validateTextDashes(value);
  isError = dashValidations.isError;
  errorCode = dashValidations.errorCode;

  if(!isOnChangeEventValidation){
    const nameOrLastnameValidation = validateNameOrLastnameCommonPatterns(key, value, required);
    isError = isError || nameOrLastnameValidation.isError;
    errorCode = errorCode || nameOrLastnameValidation.errorCode;
  }

  return {
    isError,
    errorCode,
  }
}

export const validateTextDashes = (text: string) => {
  const anyDashInText = new RegExp(/.*-.*/);
  const consecutiveDashes = new RegExp(/--/);
  const beginOrEndDash = new RegExp(/^-|-$/);
  const spaceAroundDash = new RegExp(/\s-|-\s/);
  const twoCharactersAroundDash = new RegExp(/.{2}-.{2}/);
  const onlyLettersBeforeAndAfterDash = new RegExp(/[a-zA-ZáéíóúÁÉÍÓÚñÑçÇüÜ]{1,}-[a-zA-ZáéíóúÁÉÍÓÚñÑçÇüÜ]{1,}/);

  let isError = false;
  let errorCode = '';

  //Only if there is at least one dash, the other dash patterns have to be checked.
  if(anyDashInText.test(text)) {

    if(consecutiveDashes.test(text)){
      errorCode = 'consecutive-dashes-error';
    }else if(beginOrEndDash.test(text)){
      errorCode = 'begin-or-end-dash-error';
    }else if(spaceAroundDash.test(text)){
      errorCode = 'space-around-dash-error';
    }else if(!twoCharactersAroundDash.test(text)){
      errorCode = 'not-two-characters-before-and-after-dash-error';
    }else if(!onlyLettersBeforeAndAfterDash.test(text)){
      errorCode = 'not-only-letters-before-and-after-dash-error';
    }

  }

  if(errorCode) isError = true;

  return {
    isError,
    errorCode,
  };

}


export const validateNameOrLastnameCommonPatterns = (key: string, text: string, required: boolean) => {

  //(+) -> At least one 
  const onlySpaces = new RegExp(/^\s+$/);
  const validCharacters = new RegExp(/^[A-Za-zÑñÇçÄäËëÏïÖöÜüÁÉÍÓÚáéíóúŞş\s-]+$/);
  const consecutiveSpaces = new RegExp(/\s{2}/);
  const moreThanFourSpaces = new RegExp(/(?:.*\s){5,}/);
  const onlyDashes = new RegExp(/^[-]+$/);
  const boundary = `A-Za-zÀ-ÖØ-öø-ÿ0-9_`;
  const abbreviations = !key.includes('last')
    ? new RegExp(`(?:^|[^${boundary}])(fco|ma)(?=$|[^${boundary}])`, "i")
    : new RegExp(/\b(hdez|glez|fdez|rguez|jimnez|mtnez|mtinez)\b/i);

  let isError = false;
  let errorCode = '';

  text = text ? text.trim() : '';

  if(text.length === 0 && required) {

    errorCode = 'required';

  }else if(text.length > 0 ){

    if( onlySpaces.test(text) 
      || !validCharacters.test(text)
      || text.length < 2
      || consecutiveSpaces.test(text)
      || moreThanFourSpaces.test(text)
      || onlyDashes.test(text)
      || abbreviations.test(text)
    ) {
      errorCode = 'invalid-value';
    }

  }

  if(errorCode) isError = true;
  
  return {
    isError,
    errorCode,
  };

}

export const validateBirthDatePatterns = (date: string, required: boolean) => {

  let isError = false;
  let errorCode = '';

  if(date.length === 0 && required) {

    errorCode = 'required';

  }else if(date.length > 0) {

    const format = new RegExp(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/);

    if(format.test(date)){

      const [day, month, year] = date.split('/').map(Number);
      const birthDateFormatted = new Date(year, month - 1, day);
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      const isPreviousDateFromToday = birthDateFormatted.getTime() <= currentDate.getTime();
      
      const isLessThan115Years = getAge(currentDate, birthDateFormatted) < 115;

      if(!isPreviousDateFromToday
        || !isLessThan115Years){
        errorCode = 'invalid-value';
      }

    }else{
      errorCode = 'invalid-value';
    }
    
  }
  
  if(errorCode) isError = true;
  
  return {
    isError,
    errorCode,
  };

}

export const getAge = (currentDate: Date, birthDate: Date) => {
  let age = currentDate.getFullYear() - birthDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const birthMonth = birthDate.getMonth();
  const currentDay = currentDate.getDate();
  const birthDay = birthDate.getDate();

  if (
    currentMonth < birthMonth 
    || (currentMonth === birthMonth && currentDay < birthDay)
  ) {
    age--;
  }

  return age;
}

const getGenderOptions = () => {
  const validGenderOptions = ['Hombre', 'Mujer'];
  return SEX.filter(gender => validGenderOptions.includes(gender.label) && gender.label[0] === gender.code);
}

export const genderOptions = getGenderOptions()

export const getGenderLabel = (genderCode: string) => {
  const genderByCode = genderOptions.find(gender => genderCode === gender.code)
  return genderByCode ? genderByCode.label : ''
}

interface Country {
  label: string;
  value: string;
}
export const getFilteredCountries = (countryValue: string, countries: Country[]) => {
  return countries.filter((country: Country) =>
    country.label
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .includes(
        countryValue
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
      )
  )
}



export const getDocumentTypes = (nationality: string | undefined, isHealth: boolean, isUnderAgeDisabled: boolean) => {
  let docTypes: {value: string, label: string}[] = [
    { value: "", label: "" },
  ]

  if(nationality === '' || nationality === undefined){
    docTypes = [
      ...docTypes,
      { value: "NIF", label: "NIF" },
      { value: "NIE", label: "NIE" },
      { value: isHealth ? "PAS" : "PASP", label: "Pasaporte" },
      { value: "MENOR", label: "Menor" }
    ]
  }else{
    if(nationality === 'ESPA' || (nationality && nationality.toLowerCase().includes('españa'))){
      docTypes = [
        ...docTypes,
        { value: "NIF", label: "NIF" },
        { value: "MENOR", label: "Menor" }
      ]
    }else{
      docTypes = [
        ...docTypes,
        { value: "NIE", label: "NIE" },
        { value: isHealth ? "PAS" : "PASP", label: "Pasaporte" },
        { value: "MENOR", label: "Menor" }
      ]
    }
  }

  if(isUnderAgeDisabled){
    docTypes = docTypes.filter(docType => docType.value !== "MENOR")
  }

  return docTypes
}

export const isValidDocType = (docType: string, nationality: string, isHealth: boolean, isUnderAgeDisabled: boolean) => {
  return getDocumentTypes(nationality, isHealth, isUnderAgeDisabled).some(docTypeAux => docTypeAux.value === docType)
}

export const validateDocType = (docType: string, nationality: string, birthDate: string, isHealth: boolean, required: boolean, isUnderAgeDisabled: boolean, underAgeValue: number = 14) => {

  let isError = false;
  let errorCode = '';

  if(docType === '' && required){
    errorCode = 'required'
  }else if(docType === '' && !required) {
    errorCode = ''
  }else{
  
    if(!isValidDocType(docType, nationality, isHealth, isUnderAgeDisabled)) {
      errorCode = 'invalid-document-type'
    }

    if(docType === 'MENOR') {
      errorCode = errorCode || checkUnderage(birthDate, underAgeValue)
    }
  }

  if(errorCode) isError = true;
  
  return {
    isError,
    errorCode,
  };
}

export const checkUnderage = (birthDate: string, underAgeValue: number) => {
  if(!birthDate) return '';

  const [day, month, year] = birthDate.split('/').map(Number);
  const birthDateFormatted = new Date(year, month - 1, day);
  
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  if(getAge(currentDate, birthDateFormatted) >= underAgeValue){
    return 'invalid-document-due-to-birthdate';
  }else {
    return ''
  }
  
}

export const getSelfEmployedDocumentTypes = ({
  nationality,
  isInsured = false,
  hasUnderAgeOption = false,
}: {
  nationality: string | undefined;
  isInsured?: boolean;
  hasUnderAgeOption?: boolean;
}): { value: string; label: string }[] => {
  if (!nationality) {
    return [
      { value: "NIF", label: "NIF" },
      { value: "NIE", label: "NIE" },
      {
        value: "NIFA",
        label: "Número de identificación asignado por la Agencia Tributaria (NIF de oficio)",
      },
      ...(isInsured ? [{ value: "PAS", label: "Pasaporte" }] : []),
      ...(hasUnderAgeOption ? [{ value: "MENOR", label: "Menor" }] : []),
    ];
  }

  if (nationality === "ESPA" || (nationality && nationality.toLowerCase().includes("españa"))) {
    return [
      { value: "NIF", label: "NIF" },
      ...(hasUnderAgeOption ? [{ value: "MENOR", label: "Menor" }] : []),
    ];
  } else {
    return [
      { value: "NIE", label: "NIE" },
      {
        value: "NIFA",
        label: "Número de identificación asignado por la Agencia Tributaria (NIF de oficio)",
      },
      ...(hasUnderAgeOption ? [{ value: "MENOR", label: "Menor" }] : []),
      ...(isInsured ? [{ value: "PAS", label: "Pasaporte" }] : []),
    ];
  }
};

export const isValidSelfEmployedDocType = ({
  docType,
  nationality,
  isInsured = false,
  hasUnderAgeOption = false,
}: {
  docType: string,
  nationality: string,
  isInsured?: boolean,
  hasUnderAgeOption?: boolean,
}): boolean => {
  const selfEmployedDocTypes = getSelfEmployedDocumentTypes({ nationality, isInsured, hasUnderAgeOption });
  return selfEmployedDocTypes.some((doctypeItem) => doctypeItem.value === docType);
};

export const validateSelfEmployedDocType = ({
  docType,
  nationality,
  required,
  hasUnderAgeOption = false,
  isInsured = false,
  birthDate = "",
  underAgeValue = 14,
}: {
  docType: string;
  nationality: string;
  required: boolean;
  hasUnderAgeOption?: boolean;
  isInsured?: boolean;
  birthDate?: string;
  underAgeValue?: number;
}) => {
  let isError = false;
  let errorCode = "";

  if (docType === "" && required) {
    errorCode = "required";
  } else if (docType === "" && !required) {
    errorCode = "";
  } else {
    if (!isValidSelfEmployedDocType({ docType, nationality, isInsured,  hasUnderAgeOption})) {
      errorCode = "invalid-document-type";
    }

    if (docType === "MENOR") {
      errorCode = errorCode || checkUnderage(birthDate, underAgeValue);
    }
  }

  if (errorCode) isError = true;

  return {
    isError,
    errorCode,
  };
};
